module.exports = __webpack_public_path__ + "img/1247222750.3b4fc668.jpg";